import React from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();

  // ✅ Close the Bootstrap navbar after clicking a link
  const closeNavbar = () => {
    const navbar = document.getElementById("navbarCollapse");
    if (navbar && navbar.classList.contains("show")) {
      // hide() is provided by Bootstrap’s Collapse component
      window.bootstrap?.Collapse.getInstance(navbar)?.hide();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg bg-navbar navbar-light shadow sticky-top p-0">
      <a
        href="/"
        className="navbar-brand bg-navbar-a d-flex align-items-end px-4 px-lg-5"
      >
        <img src="/img/logo.png" alt="logo" style={{ width: "70px" }} />
        <h2 className="mb-2 text-primary">RSIS</h2>
      </a>
      <button
        type="button"
        className="navbar-toggler me-4"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav ms-auto p-4 p-lg-0">
          <Link
            to="/"
            onClick={closeNavbar}
            className={`nav-item nav-link ${location.pathname === "/" ? "active" : ""}`}
          >
            Home
          </Link>
          <Link
            to="/about"
            onClick={closeNavbar}
            className={`nav-item nav-link ${location.pathname === "/about" ? "active" : ""}`}
          >
            About
          </Link>
          <Link
            to="/products"
            onClick={closeNavbar}
            className={`nav-item nav-link ${location.pathname === "/products" ? "active" : ""}`}
          >
            Products
          </Link>

          <div className="nav-item dropdown">
            <Link
              to="/industries"
              onClick={closeNavbar}
              className={`nav-link ${location.pathname === "/industries" ? "active" : ""}`}
            >
              Industries <span className="dropdown-toggle" data-bs-toggle="dropdown"></span>
            </Link>
            <div className="dropdown-menu fade-up m-0">
              <Link to="/industries#automotive" className="dropdown-item" onClick={closeNavbar}>Automotive</Link>
              <Link to="/industries#food-industry" className="dropdown-item" onClick={closeNavbar}>Food Industry</Link>
              <Link to="/industries#tyre-industry" className="dropdown-item" onClick={closeNavbar}>Tyre Industry</Link>
              <Link to="/industries#machine-tool-industry" className="dropdown-item" onClick={closeNavbar}>Machine Tool Industry</Link>
              <Link to="/industries#mining" className="dropdown-item" onClick={closeNavbar}>Mining</Link>
              <Link to="/industries#oil-gas" className="dropdown-item" onClick={closeNavbar}>Oil & Gas</Link>
            </div>
          </div>

          <Link
            to="/contact"
            onClick={closeNavbar}
            className={`nav-item nav-link ${location.pathname === "/contact" ? "active" : ""}`}
          >
            Contact
          </Link>
        </div>
        <h4 className="m-0 pe-lg-5 d-none d-lg-block">
          <i className="fa fa-headphones text-primary me-3"></i>+91-8368771407
        </h4>
      </div>
    </nav>
  );
};

export default Navbar;
